// Core
import React, { useEffect, useCallback, useState } from 'react';
import { Box, Button, Flex, Grid, Text, Image, useColorMode } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import activePlan from 'assets/img/active-plans.png';

// Components
import { StarsIcon, StarsWhiteIcon } from 'components/Icons/Icons';

const ActivePlans = (props) => { 
  const { userData, activePlans } = props;

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const styleText = {
  	variant: 'title-lg',
  	fontSize: '24px',
  	fontStyle: 'italic',
  	fontWeight: '800',
		textTransform: 'uppercase',
  	color: 'white'
  };

  return (
	<>
		<Box p="16px 16px 16px 12px" borderRadius="16px" position="relative" overflow="hidden" bg="lightgray">
			<Image 
				zIndex="1"
				opacity="1"
				src={activePlan} alt="Profile" 
				right="0" top="0" objectFit="cover" position="absolute" w="100%" h="100%"/>

			<Box zIndex="1" position="relative">
				<Box mt="-2px">
					<Flex gap="8px">
					  <Text style={styleText}>
					    You have
					  </Text>
					  <Text style={styleText}>
						  <Flex as="span" gap="3px" alignItems="center">
					    	<StarsWhiteIcon fontSize="16px" />
					    	<span style={{
					    		borderRadius: '16px',
									background: '#FFF',
									padding: '0px 11px 0px 8px',
									color: '#099BFF'
					    	}}>{activePlans?.length}</span>
					    	<StarsWhiteIcon fontSize="16px" />
					    </Flex>
					  </Text>
				  </Flex>
				  <Text style={styleText}>
				  	Active subscriptions
				  </Text>
				</Box>

				<Text mt="4px" variant="title-lg" fontSize="24px" fontStyle="normal" fontWeight="700" color="white">
				    ${userData?.activePlan?.price / 100} <span style={{fontSize: '17px', marginLeft: '-5px'}}>/{userData?.activePlan?.paymentType === 'monthly' ? 'month' : 'year' }</span>
				</Text>

				{/*<Box mt="16px">
					<NavLink to='/account/membership/subscriptions'>
						 <Text
				        variant="title-md"
				        h="26px"
				        textAlign="center"
				        w="150px"
				        padding="3px 9px"
				        borderRadius="100px"
				        cursor="pointer"
				        bg={ isDark ? '#0F1426' : 'white'}>View All</Text>
					</NavLink>
				</Box>*/}

			</Box>
		</Box>

	</>
  );
};

export default ActivePlans;